import { Schema } from 'effect';

/**
 * @see https://schema.org/ListItem
 */
export const ListItemSchemaOrg = Schema.Struct({
  '@type': Schema.Literal('ListItem'),
  item: Schema.optional(Schema.String),
  position: Schema.Finite,
  name: Schema.String,
});
